import React, { Component } from 'react';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { IGuidesManager } from '@src/slide/application/service/guides-manager/index.interface';
import { observer } from 'mobx-react';
import GuideColorCell from '@com/guides-line/guide-color-cell';
import styles from './guides-color-panel.less';
import i18n from '@i18next/i18n';
import { reaction, transaction } from 'mobx';

interface IGuidesColorPanelProps {
    menuManager: IMenuManager;
}

export const DEFAULT_GUIDE_COLOR = 'A7A7A7';
export const DEFAULT_MASTER_GUIDE_COLOR = 'F67D79';
export const DEFAULT_LAYOUT_GUIDE_COLOR = 'FFA85C';

const COLOR_LIST = [
    {
        tips: i18n.t('灰'),
        color: DEFAULT_GUIDE_COLOR,
        key: 'gray',
    },
    {
        tips: i18n.t('红'),
        color: DEFAULT_MASTER_GUIDE_COLOR,
        key: 'red',
    },
    {
        tips: i18n.t('橙'),
        color: DEFAULT_LAYOUT_GUIDE_COLOR,
        key: 'orange',
    },
    {
        tips: i18n.t('黄'),
        color: 'FFDA47',
        key: 'yellow',
    },
    {
        tips: i18n.t('绿'),
        color: '7BCCA0',
        key: 'green',
    },
    {
        tips: i18n.t('青'),
        color: '70CFFF',
        key: 'cyan',
    },
    {
        tips: i18n.t('蓝'),
        color: '70A3FF',
        key: 'blue',
    },
    {
        tips: i18n.t('紫'),
        color: 'C464FF',
        key: 'purple',
    },
    {
        tips: i18n.t('黑'),
        color: '000000',
        key: 'black',
    },
    {
        tips: i18n.t('白'),
        color: 'FFFFFF',
        key: 'white',
    },
];

/**
 * 参考线色板
 */
@observer
export default class GuidesColorPanel extends Component<IGuidesColorPanelProps> {
    private guidesManager?: IGuidesManager;

    constructor(props: IGuidesColorPanelProps) {
        super(props);
        const { menuManager } = props;
        this.guidesManager = menuManager.guidesManager;
        reaction(() => [
            this.guidesManager?.currentGuideModelMap,
        ], () => {
            this.forceUpdate();
        });
    }

    render() {
        return <div className={styles.guidesColorPanelContainer}>
            {
                COLOR_LIST.map(item => <GuideColorCell
                    handleColorChange={this.handleColorChange}
                    color={item.color}
                    key={item.color}
                    tips={item.tips}
                    selected={this.guidesManager?.currentGuideModelMap.guide?.color === item.color}
                />)
            }
        </div>;
    }

    private handleColorChange = (color) => {
        transaction(() => {
            if (this.guidesManager?.currentGuideModelMap.guide) {
                this.guidesManager.setCurrentGuideColor(color);
            }
        });
    };
}
